import React, { createContext, useReducer } from 'react'
import PropTypes from 'prop-types'

const initialState = {
  isOpen: false,
  isLoading: false,
  type: "booking",
  bookingOpen: false,
  salesOpen: false,
  title: '',
  blurb: '',
  hotel: null,
  data: null,
  size: "lg"
}

export const PACKAGES_MODAL = {
  IS_OPEN: {
    SET: 'PACKAGES_MODAL/IS_OPEN/SET'
  },
  IS_LOADING: {
    SET: 'PACKAGES_MODAL/IS_LOADING/SET'
  },
  TYPE: {
    SET: 'PACKAGES_MODAL/TYPE/SET'
  },
  BOOKING_OPEN: {
    SET: 'PACKAGES_MODAL/BOOKING_OPEN/SET'
  },
  SALES_OPEN: {
    SET: 'PACKAGES_MODAL/SALES_OPEN/SET'
  },
  TITLE: {
    SET: 'PACKAGES_MODAL/TITLE/SET'
  },
  BLURB: {
    SET: 'PACKAGES_MODAL/BLURB/SET'
  },
  HOTEL: {
    SET: 'PACKAGES_MODAL/HOTEL/SET'
  },
  DATA: {
    SET: 'PACKAGES_MODAL/DATA/SET'
  },
  SIZE: {
    SET: 'PACKAGES_MODAL/SIZE/SET'
  }
}

let reducer = ( state, action ) => {
  switch(action.type) {
    case "reset":
      return initialState
    case PACKAGES_MODAL.IS_OPEN.SET:
      return { ...state, isOpen: action.payload }
    case PACKAGES_MODAL.IS_LOADING.SET:
      return { ...state, isLoading: action.payload }
    case PACKAGES_MODAL.TYPE.SET:
      return { ...state, type: action.payload }
    case PACKAGES_MODAL.BOOKING_OPEN.SET:
      return { ...state, bookingOpen: action.payload }
    case PACKAGES_MODAL.SALES_OPEN.SET:
      return { ...state, salesOpen: action.payload }
    case PACKAGES_MODAL.TITLE.SET:
      return { ...state, title: action.payload }
    case PACKAGES_MODAL.BLURB.SET:
      return { ...state, blurb: action.payload }
    case PACKAGES_MODAL.HOTEL.SET:
      return { ...state, hotel: action.payload }
    case PACKAGES_MODAL.DATA.SET:
      return { ...state, data: action.payload }
    case PACKAGES_MODAL.SIZE.SET:
      return { ...state, size: action.payload }
    default:
      return state
  }
}

export const PackagesModalContext = createContext()

export const PackagesModalProvider = ({ children }) => {
  let [state, dispatch] = useReducer(reducer, initialState)
  let value = { state, dispatch }

  return (
    <PackagesModalContext.Provider value={ value }>
      { children }
    </PackagesModalContext.Provider>
  )
}

PackagesModalProvider.propTypes = {
  children: PropTypes.node
}

export const PackagesModalConsumer = PackagesModalContext.Consumer
